import React, {useEffect} from "react";
import {useFieldArray} from "react-hook-form";
import TextInput from "../../Components/Inputs/TextInput";
import AddItemButton from "../../Components/Buttons/AddItemButton";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";

export default function ({control, errors, register, data}) {
  const {fields, append, remove} = useFieldArray({
    control,
    name: "codes",
    keyName: "index",
  });

  return (
    <div className="card card-flush py-4 mt-3">
      <div className="card-header">
        <div className="card-title">
          <h2>Category codes</h2>
        </div>
        {errors?.codes && (
          <div className="fv-plugins-message-container invalid-feedback mb-5">
            <div>{errors.codes}</div>
          </div>
        )}
      </div>

      <div className="card-body pt-0">
        <div className="fv-row">
          {fields.map((item, index) => {
            return <div key={item.index} className="d-flex gap-3">
              {item?.id && (
                <input
                  type="hidden"
                  {...register(`codes.${index}.id`)}
                />
              )}

              <div className='w-50'>
                <ReactSelectInput
                  label='Shop'
                  name={`codes.${index}.shop_id`}
                  errorMessage={errors?.[`codes.${index}.shop_id`]}
                  control={control}
                  options={data?.shops}
                />
              </div>

              <div className='w-50'>
                <TextInput
                  label='Code'
                  name={`codes.${index}.code`}
                  register={register}
                  errorMessage={errors?.[`codes.${index}.code`]}
                />
              </div>

              <button
                type="button"
                onClick={() => remove(index)}
                className="btn btn-danger btn-hover-scale btn-size"
              >
                -
              </button>
            </div>
          })}

          <AddItemButton title='Add' onClick={() => append({
            code: '',
          })}/>
        </div>
      </div>
    </div>
  );
}